import { render, staticRenderFns } from "./video_list_hfwl.vue?vue&type=template&id=1128b129"
import script from "./video_list_hfwl.vue?vue&type=script&lang=js"
export * from "./video_list_hfwl.vue?vue&type=script&lang=js"
import style0 from "./video_list_hfwl.vue?vue&type=style&index=0&id=1128b129&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports